import { AssessmentStepKeys } from '@/enums'
import { makeBusinessTypeSubmitValue } from '../../helpers'
import { ConditionalOfferAssessment } from './BasePage'

interface StepProps {
  [key: string]: {
    categoryId?: string
    helperText?: string
  }
}

interface Messages {
  helperText: string
}

interface SubmitValues {
  approxRevenue: any
  businessType: any
  companyFoundedDateLead: any
  costOfElectronics: any
  [key: string]: any
}

const electronicsAssessmentSteps = [
  AssessmentStepKeys.businessTypeAi,
  AssessmentStepKeys.businessTypeConfirmationAi,
  AssessmentStepKeys.businessTypeMainSelectionAi,
  AssessmentStepKeys.companyFoundedDateLead,
  AssessmentStepKeys.approxRevenue,
  AssessmentStepKeys.costOfElectronics,
]

const categoryId = 'EL'

const makeSubmitValues = () => {
  return function transform<T>(values: T): T {
    const typedValues = values as SubmitValues
    const {
      approxRevenue,
      businessType,
      companyFoundedDateLead,
      costOfElectronics,
      ...steps
    } = typedValues
    return ({
      ...steps,
      lastYearFinances: { ...approxRevenue, ...costOfElectronics },
      businessType: makeBusinessTypeSubmitValue(businessType),
      companyFoundedDate: companyFoundedDateLead,
    } as unknown) as T
  }
}

const makeStepProps = (messages: Messages): StepProps => ({
  [AssessmentStepKeys.businessTypeConfirmationAi]: {
    categoryId,
  },
  [AssessmentStepKeys.approxRevenue]: {
    helperText: messages.helperText,
  },
})

export const ElectronicsConditionalOffer = () => (
  <ConditionalOfferAssessment
    categoryId={categoryId}
    makeStepProps={makeStepProps}
    stepKeys={electronicsAssessmentSteps}
    transformSubmitValues={makeSubmitValues()}
  />
)
